const $b711c676d788cd32$var$CSV_URL = "https://firebasestorage.googleapis.com/v0/b/stipendee.firebasestorage.app/o/osservatorio%2Fdataset.csv?alt=media";
var $c83da2fae98689c3$exports = {};
$c83da2fae98689c3$exports = import.meta.resolve("gr524");


const $b711c676d788cd32$var$GEOJSON_URL = new URL($c83da2fae98689c3$exports).toString();
const $b711c676d788cd32$var$BIN_SCALES = [
    {
        max: 50000,
        step: 5000
    },
    {
        max: 100000,
        step: 10000
    },
    {
        max: 200000,
        step: 20000
    },
    {
        max: Infinity,
        step: 50000
    }
];
const $b711c676d788cd32$var$MIN_SAMPLE = 3;
const $b711c676d788cd32$var$TRIM_LOWER = 0.005;
const $b711c676d788cd32$var$TRIM_UPPER = 0.995;
const $b711c676d788cd32$var$MIN_RAL = 5000;
const $b711c676d788cd32$var$LIVELLO_ORDER = [
    "Operaio",
    "Impiegato",
    "Quadro",
    "Dirigente"
];
const $b711c676d788cd32$var$DIMENSIONE_ORDER = [
    "1-10",
    "11-50",
    "51-200",
    "201-500",
    "501-1000",
    "1001-5000",
    "Oltre 5000"
];
const $b711c676d788cd32$var$ETA_ORDER = [
    "16-18",
    "18-25",
    "26-30",
    "31-35",
    "36-45",
    "46-55",
    "56-65",
    "66+"
];
const $b711c676d788cd32$var$ESPERIENZA_ORDER = [
    "0-1",
    "2-5",
    "6-10",
    "11-20",
    "21+"
];
const $b711c676d788cd32$var$TITOLO_STUDIO_ORDER = [
    "Altro",
    "Diploma",
    "Laurea triennale",
    "Laurea magistrale",
    "Master / MBA",
    "PhD / Dottorato"
];
const $b711c676d788cd32$var$SENIORITY_ORDER = [
    "Entry-Level",
    "Junior",
    "Mid-Level",
    "Senior",
    "Lead",
    "Team Lead",
    "Lead / Team Lead",
    "Manager",
    "Director / VP",
    "Executive / C-Level"
];
const $b711c676d788cd32$var$state = {
    raw: [],
    filtered: [],
    charts: {},
    geo: null,
    chartReady: new Set()
};
const $b711c676d788cd32$var$currency = new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});
const $b711c676d788cd32$var$numberFormat = new Intl.NumberFormat("it-IT", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 1
});
const $b711c676d788cd32$var$countFormat = new Intl.NumberFormat("it-IT", {
    maximumFractionDigits: 0
});
function $b711c676d788cd32$var$normalizeValue(value) {
    if (value === null || value === undefined) return "";
    const stringValue = String(value).trim();
    return stringValue === "" ? "" : stringValue;
}
function $b711c676d788cd32$var$parseRal(value) {
    const numeric = Number(String(value).replace(/[^0-9.]/g, ""));
    return Number.isFinite(numeric) ? numeric : null;
}
function $b711c676d788cd32$var$parseScale(value) {
    const numeric = Number(String(value).replace(/[^0-9.]/g, ""));
    return Number.isFinite(numeric) ? numeric : null;
}
function $b711c676d788cd32$var$scaleToPercent(value) {
    if (value === null || value === undefined) return null;
    return value / 5 * 100;
}
function $b711c676d788cd32$var$formatDate(value) {
    if (!value) return "--";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "--";
    return date.toLocaleDateString("it-IT", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
}
function $b711c676d788cd32$var$setChartEmpty(canvasId, isEmpty, message = "Campione insufficiente") {
    const canvas = document.getElementById(canvasId);
    if (!canvas) return;
    const panel = canvas.closest(".panel");
    if (!panel) return;
    let messageEl = panel.querySelector(".chart-empty-message");
    if (!messageEl) {
        messageEl = document.createElement("div");
        messageEl.className = "chart-empty-message";
        panel.appendChild(messageEl);
    }
    messageEl.textContent = message;
    panel.classList.toggle("is-empty", isEmpty);
}
function $b711c676d788cd32$var$setOptions(select, values) {
    const options = [
        "",
        ...values
    ];
    select.innerHTML = "";
    options.forEach((value)=>{
        const option = document.createElement("option");
        option.value = value;
        option.textContent = value === "" ? "Tutti" : value;
        select.appendChild(option);
    });
}
function $b711c676d788cd32$var$setOptionsOrdered(select, order, values) {
    const ordered = [
        ...order.filter((value)=>values.includes(value)),
        ...values.filter((value)=>!order.includes(value))
    ];
    $b711c676d788cd32$var$setOptions(select, ordered);
}
function $b711c676d788cd32$var$uniqueValues(data, field) {
    const set = new Set();
    data.forEach((row)=>{
        const value = $b711c676d788cd32$var$normalizeValue(row[field]);
        if (value) set.add(value);
    });
    return Array.from(set).sort((a, b)=>a.localeCompare(b, "it"));
}
function $b711c676d788cd32$var$computeStats(values, trim = true) {
    const source = trim ? $b711c676d788cd32$var$trimOutliers(values, $b711c676d788cd32$var$TRIM_LOWER, $b711c676d788cd32$var$TRIM_UPPER) : values;
    const numeric = source.filter((value)=>typeof value === "number").sort((a, b)=>a - b);
    if (numeric.length < $b711c676d788cd32$var$MIN_SAMPLE) return {
        avg: null,
        median: null,
        min: null,
        max: null
    };
    const sum = numeric.reduce((acc, val)=>acc + val, 0);
    const mid = Math.floor(numeric.length / 2);
    const median = numeric.length % 2 ? numeric[mid] : (numeric[mid - 1] + numeric[mid]) / 2;
    return {
        avg: sum / numeric.length,
        median: median,
        min: numeric[0],
        max: numeric[numeric.length - 1]
    };
}
function $b711c676d788cd32$var$trimOutliers(values, lowerPercent = $b711c676d788cd32$var$TRIM_LOWER, upperPercent = $b711c676d788cd32$var$TRIM_UPPER, minValue = null) {
    const numeric = values.filter((value)=>typeof value === "number").filter((value)=>minValue === null ? true : value >= minValue).sort((a, b)=>a - b);
    if (numeric.length < $b711c676d788cd32$var$MIN_SAMPLE) return [];
    let lowerIndex = Math.floor(numeric.length * lowerPercent);
    let upperIndex = Math.ceil(numeric.length * upperPercent) - 1;
    if (numeric.length >= $b711c676d788cd32$var$MIN_SAMPLE + 2) {
        if (lowerIndex === 0) lowerIndex = 1;
        if (upperIndex >= numeric.length - 1) upperIndex = numeric.length - 2;
    }
    const start = Math.max(0, lowerIndex);
    const end = Math.min(numeric.length - 1, upperIndex);
    return numeric.slice(start, end + 1);
}
function $b711c676d788cd32$var$trimRal(values) {
    return $b711c676d788cd32$var$trimOutliers(values, $b711c676d788cd32$var$TRIM_LOWER, $b711c676d788cd32$var$TRIM_UPPER, $b711c676d788cd32$var$MIN_RAL);
}
function $b711c676d788cd32$var$buildVariableBins(values) {
    const numeric = values.filter((value)=>typeof value === "number" && value >= 0);
    if (!numeric.length) return {
        labels: [],
        counts: []
    };
    const maxValue = Math.max(...numeric);
    const bins = [];
    let start = 0;
    let scaleIndex = 0;
    while(start <= maxValue){
        const scale = $b711c676d788cd32$var$BIN_SCALES[scaleIndex] || $b711c676d788cd32$var$BIN_SCALES[$b711c676d788cd32$var$BIN_SCALES.length - 1];
        const step = scale.step;
        const end = Math.min(start + step, scale.max);
        bins.push({
            start: start,
            end: end
        });
        start = end;
        if (start >= scale.max && scaleIndex < $b711c676d788cd32$var$BIN_SCALES.length - 1) scaleIndex += 1;
        if (scale.max === Infinity && start >= maxValue) break;
    }
    const counts = new Array(bins.length).fill(0);
    numeric.forEach((value)=>{
        const binIndex = bins.findIndex((bin)=>value >= bin.start && value < bin.end);
        if (binIndex >= 0) counts[binIndex] += 1;
    });
    const labels = bins.map((bin)=>`${Math.round(bin.start / 1000)}k-${Math.round(bin.end / 1000)}k`);
    const filtered = labels.map((label, index)=>({
            label: label,
            count: counts[index]
        })).filter((entry)=>entry.count >= $b711c676d788cd32$var$MIN_SAMPLE);
    return {
        labels: filtered.map((entry)=>entry.label),
        counts: filtered.map((entry)=>entry.count)
    };
}
function $b711c676d788cd32$var$buildCategoryCounts(data, field, options = {}) {
    const counts = {};
    const unknownLabel = options.unknownLabel || "Non specificato";
    const minCount = options.minCount || 1;
    data.forEach((row)=>{
        const rawValue = $b711c676d788cd32$var$normalizeValue(row[field]);
        const value = rawValue || unknownLabel;
        counts[value] = (counts[value] || 0) + 1;
    });
    let labels;
    if (options.order && options.order.length) {
        const ordered = options.order.filter((value)=>counts[value]);
        const remaining = Object.keys(counts).filter((value)=>!options.order.includes(value)).sort((a, b)=>counts[b] - counts[a]);
        labels = [
            ...ordered,
            ...remaining
        ];
    } else labels = Object.keys(counts).sort((a, b)=>counts[b] - counts[a]);
    if (options.limit && labels.length > options.limit) {
        const top = labels.slice(0, options.limit);
        const rest = labels.slice(options.limit);
        const restCount = rest.reduce((acc, label)=>acc + counts[label], 0);
        if (restCount >= minCount) {
            counts.Altro = restCount;
            top.push("Altro");
        }
        labels = top;
    }
    labels = labels.filter((label)=>counts[label] >= minCount);
    return {
        labels: labels,
        data: labels.map((label)=>counts[label] || 0)
    };
}
function $b711c676d788cd32$var$updateCategoryChart(key, canvasId, labels, data, color, options = {}) {
    const indexAxis = options.indexAxis || "x";
    const yCurrency = options.yCurrency || false;
    const datasetLabel = options.datasetLabel || "Risposte";
    const yScale = options.yScale || {};
    const transform = options.transform || null;
    const rawData = options.rawData || null;
    const isLog = yScale.type === "logarithmic";
    if (!$b711c676d788cd32$var$state.charts[key]) $b711c676d788cd32$var$state.charts[key] = new Chart(document.getElementById(canvasId), {
        type: "bar",
        data: {
            labels: labels,
            datasets: [
                {
                    label: datasetLabel,
                    data: data,
                    rawData: rawData,
                    backgroundColor: color.background,
                    borderColor: color.border,
                    borderWidth: 1
                }
            ]
        },
        options: {
            responsive: true,
            indexAxis: indexAxis,
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>{
                            const value = context.dataset.rawData ? context.dataset.rawData[context.dataIndex] : context.parsed.y;
                            if (yCurrency) return `${datasetLabel}: ${$b711c676d788cd32$var$currency.format(value)}`;
                            return `${datasetLabel}: ${value}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257"
                    },
                    beginAtZero: true
                },
                y: {
                    type: yScale.type || "linear",
                    min: yScale.min,
                    max: yScale.max,
                    ticks: yCurrency ? {
                        color: "#6b6257",
                        callback: (value)=>$b711c676d788cd32$var$currency.format(value)
                    } : {
                        color: "#6b6257",
                        callback: (value)=>{
                            if (transform === "sqrt") return Math.round(value * value);
                            return isLog && Number.isInteger(value) ? value : value;
                        }
                    },
                    beginAtZero: !isLog
                }
            }
        }
    });
    else {
        $b711c676d788cd32$var$state.charts[key].data.labels = labels;
        $b711c676d788cd32$var$state.charts[key].data.datasets[0].data = data;
        $b711c676d788cd32$var$state.charts[key].data.datasets[0].label = datasetLabel;
        $b711c676d788cd32$var$state.charts[key].data.datasets[0].rawData = rawData;
        $b711c676d788cd32$var$state.charts[key].update();
    }
}
function $b711c676d788cd32$var$updateCharts(filtered) {
    const isReady = (id)=>$b711c676d788cd32$var$state.chartReady.has(id);
    const ralValues = filtered.map((row)=>$b711c676d788cd32$var$parseRal(row.ral)).filter((value)=>value !== null);
    const ralTrimmed = $b711c676d788cd32$var$trimRal(ralValues);
    const { labels: labels, counts: counts } = $b711c676d788cd32$var$buildVariableBins(ralTrimmed);
    const hasRalData = labels.length > 0;
    if (isReady("ral-chart")) {
        $b711c676d788cd32$var$setChartEmpty("ral-chart", !hasRalData);
        if (!hasRalData) {
            if ($b711c676d788cd32$var$state.charts.ral) {
                $b711c676d788cd32$var$state.charts.ral.destroy();
                $b711c676d788cd32$var$state.charts.ral = null;
            }
        }
    }
    if (isReady("ral-chart") && hasRalData && !$b711c676d788cd32$var$state.charts.ral) $b711c676d788cd32$var$state.charts.ral = new Chart(document.getElementById("ral-chart"), {
        type: "bar",
        data: {
            labels: labels,
            datasets: [
                {
                    label: "Risposte",
                    data: counts,
                    rawCounts: counts,
                    backgroundColor: "rgba(255, 138, 0, 0.6)",
                    borderColor: "#ff8a00",
                    borderWidth: 1
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>{
                            const raw = context.dataset.rawCounts?.[context.dataIndex] ?? context.parsed.y;
                            return `Risposte: ${$b711c676d788cd32$var$countFormat.format(raw)}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257"
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257"
                    },
                    beginAtZero: true
                }
            }
        }
    });
    else if (isReady("ral-chart") && hasRalData && $b711c676d788cd32$var$state.charts.ral) {
        $b711c676d788cd32$var$state.charts.ral.data.labels = labels;
        $b711c676d788cd32$var$state.charts.ral.data.datasets[0].data = counts;
        $b711c676d788cd32$var$state.charts.ral.data.datasets[0].rawCounts = counts;
        $b711c676d788cd32$var$state.charts.ral.update();
    }
    const seniorityBuckets = {};
    filtered.forEach((row)=>{
        const value = $b711c676d788cd32$var$normalizeValue(row.seniority) || "Non specificato";
        const ralValue = $b711c676d788cd32$var$parseRal(row.ral);
        if (!seniorityBuckets[value]) seniorityBuckets[value] = [];
        if (ralValue !== null) seniorityBuckets[value].push(ralValue);
    });
    const seniorityLabels = [
        ...$b711c676d788cd32$var$SENIORITY_ORDER.filter((value)=>seniorityBuckets[value]?.length >= $b711c676d788cd32$var$MIN_SAMPLE),
        ...Object.keys(seniorityBuckets).filter((value)=>!$b711c676d788cd32$var$SENIORITY_ORDER.includes(value) && seniorityBuckets[value]?.length >= $b711c676d788cd32$var$MIN_SAMPLE)
    ];
    const seniorityTrimmed = seniorityLabels.map((label)=>$b711c676d788cd32$var$trimRal(seniorityBuckets[label]));
    const seniorityCounts = seniorityTrimmed.map((values)=>values.length);
    const seniorityAvg = seniorityTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).avg);
    const seniorityMedian = seniorityTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).median);
    const hasSeniority = seniorityLabels.length > 0;
    if (isReady("seniority-chart")) {
        $b711c676d788cd32$var$setChartEmpty("seniority-chart", !hasSeniority);
        if (!hasSeniority) {
            if ($b711c676d788cd32$var$state.charts.seniority) {
                $b711c676d788cd32$var$state.charts.seniority.destroy();
                $b711c676d788cd32$var$state.charts.seniority = null;
            }
        }
    }
    if (isReady("seniority-chart") && hasSeniority && !$b711c676d788cd32$var$state.charts.seniority) $b711c676d788cd32$var$state.charts.seniority = new Chart(document.getElementById("seniority-chart"), {
        type: "bar",
        data: {
            labels: seniorityLabels,
            datasets: [
                {
                    type: "bar",
                    label: "Risposte",
                    data: seniorityCounts,
                    rawCounts: seniorityCounts,
                    backgroundColor: "rgba(33, 76, 205, 0.35)",
                    borderColor: "#214ccd",
                    borderWidth: 1,
                    yAxisID: "y"
                },
                {
                    type: "line",
                    label: "RAL media",
                    data: seniorityAvg,
                    borderColor: "#0b7a75",
                    backgroundColor: "rgba(11, 122, 117, 0.15)",
                    pointBackgroundColor: "#0b7a75",
                    tension: 0.3,
                    yAxisID: "yRal"
                },
                {
                    type: "line",
                    label: "RAL mediana",
                    data: seniorityMedian,
                    borderColor: "#ff8a00",
                    backgroundColor: "rgba(255, 138, 0, 0.15)",
                    pointBackgroundColor: "#ff8a00",
                    tension: 0.3,
                    yAxisID: "yRal"
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>{
                            if (context.dataset.label === "Risposte") {
                                const raw = context.dataset.rawCounts?.[context.dataIndex] ?? context.parsed.y;
                                return `Risposte: ${$b711c676d788cd32$var$countFormat.format(raw)}`;
                            }
                            return `${context.dataset.label}: ${$b711c676d788cd32$var$currency.format(context.parsed.y)}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257"
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257"
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "Risposte"
                    }
                },
                yRal: {
                    position: "right",
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>$b711c676d788cd32$var$currency.format(value)
                    },
                    grid: {
                        drawOnChartArea: false
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "RAL (\u20AC)"
                    }
                }
            }
        }
    });
    else if (isReady("seniority-chart") && hasSeniority && $b711c676d788cd32$var$state.charts.seniority) {
        $b711c676d788cd32$var$state.charts.seniority.data.labels = seniorityLabels;
        $b711c676d788cd32$var$state.charts.seniority.data.datasets[0].data = seniorityCounts;
        $b711c676d788cd32$var$state.charts.seniority.data.datasets[0].rawCounts = seniorityCounts;
        $b711c676d788cd32$var$state.charts.seniority.data.datasets[1].data = seniorityAvg;
        $b711c676d788cd32$var$state.charts.seniority.data.datasets[2].data = seniorityMedian;
        $b711c676d788cd32$var$state.charts.seniority.update();
    }
    const genereOrder = [
        "Uomo",
        "Donna",
        "Non binario",
        "Preferisco non dire"
    ];
    const genereBuckets = {};
    filtered.forEach((row)=>{
        const value = $b711c676d788cd32$var$normalizeValue(row.genere);
        if (!value) return;
        const ralValue = $b711c676d788cd32$var$parseRal(row.ral);
        if (ralValue === null) return;
        if (!genereBuckets[value]) genereBuckets[value] = [];
        genereBuckets[value].push(ralValue);
    });
    const genereLabels = [
        ...genereOrder.filter((value)=>genereBuckets[value]?.length >= $b711c676d788cd32$var$MIN_SAMPLE),
        ...Object.keys(genereBuckets).filter((value)=>!genereOrder.includes(value) && genereBuckets[value]?.length >= $b711c676d788cd32$var$MIN_SAMPLE)
    ];
    const genereTrimmed = genereLabels.map((label)=>$b711c676d788cd32$var$trimRal(genereBuckets[label] || []));
    const genereData = genereTrimmed.map((values)=>{
        if (values.length < $b711c676d788cd32$var$MIN_SAMPLE) return null;
        const sum = values.reduce((acc, val)=>acc + val, 0);
        return sum / values.length;
    });
    const genereLabelsFiltered = genereLabels.filter((_, index)=>genereTrimmed[index].length >= $b711c676d788cd32$var$MIN_SAMPLE);
    const genereDataFiltered = genereData.filter((value)=>value !== null);
    const hasGenere = genereLabelsFiltered.length > 0;
    if (isReady("genere-chart")) {
        $b711c676d788cd32$var$setChartEmpty("genere-chart", !hasGenere);
        if (!hasGenere) {
            if ($b711c676d788cd32$var$state.charts.genere) {
                $b711c676d788cd32$var$state.charts.genere.destroy();
                $b711c676d788cd32$var$state.charts.genere = null;
            }
        }
    }
    if (isReady("genere-chart") && hasGenere) $b711c676d788cd32$var$updateCategoryChart("genere", "genere-chart", genereLabelsFiltered, genereDataFiltered, {
        background: "rgba(9, 105, 106, 0.6)",
        border: "#09696a"
    }, {
        yCurrency: true,
        datasetLabel: "RAL media"
    });
    const rapportoBuckets = {};
    filtered.forEach((row)=>{
        const value = $b711c676d788cd32$var$normalizeValue(row.rapporto);
        if (!value) return;
        const ralValue = $b711c676d788cd32$var$parseRal(row.ral);
        if (!rapportoBuckets[value]) rapportoBuckets[value] = [];
        if (ralValue !== null) rapportoBuckets[value].push(ralValue);
    });
    const rapportoLabels = Object.keys(rapportoBuckets).filter((label)=>rapportoBuckets[label].length >= $b711c676d788cd32$var$MIN_SAMPLE).sort((a, b)=>rapportoBuckets[b].length - rapportoBuckets[a].length);
    const rapportoTrimmed = rapportoLabels.map((label)=>$b711c676d788cd32$var$trimRal(rapportoBuckets[label]));
    const rapportoCounts = rapportoTrimmed.map((values)=>values.length);
    const rapportoCountsCompressed = rapportoCounts.map((value)=>Math.sqrt(value));
    const rapportoAvg = rapportoTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).avg);
    const rapportoMedian = rapportoTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).median);
    const hasRapporto = rapportoLabels.length > 0;
    if (isReady("rapporto-chart")) {
        $b711c676d788cd32$var$setChartEmpty("rapporto-chart", !hasRapporto);
        if (!hasRapporto) {
            if ($b711c676d788cd32$var$state.charts.rapporto) {
                $b711c676d788cd32$var$state.charts.rapporto.destroy();
                $b711c676d788cd32$var$state.charts.rapporto = null;
            }
        }
    }
    if (isReady("rapporto-chart") && hasRapporto && !$b711c676d788cd32$var$state.charts.rapporto) $b711c676d788cd32$var$state.charts.rapporto = new Chart(document.getElementById("rapporto-chart"), {
        type: "bar",
        data: {
            labels: rapportoLabels,
            datasets: [
                {
                    label: "Risposte",
                    data: rapportoCountsCompressed,
                    rawCounts: rapportoCounts,
                    backgroundColor: "rgba(33, 76, 205, 0.35)",
                    borderColor: "#214ccd",
                    borderWidth: 1,
                    yAxisID: "y"
                },
                {
                    label: "RAL media",
                    data: rapportoAvg,
                    borderColor: "#0b7a75",
                    backgroundColor: "rgba(11, 122, 117, 0.15)",
                    pointBackgroundColor: "#0b7a75",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                },
                {
                    label: "RAL mediana",
                    data: rapportoMedian,
                    borderColor: "#ff8a00",
                    backgroundColor: "rgba(255, 138, 0, 0.15)",
                    pointBackgroundColor: "#ff8a00",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>{
                            if (context.dataset.label === "Risposte") {
                                const raw = context.dataset.rawCounts?.[context.dataIndex] ?? context.parsed.y;
                                return `Risposte: ${$b711c676d788cd32$var$countFormat.format(raw)}`;
                            }
                            return `${context.dataset.label}: ${$b711c676d788cd32$var$currency.format(context.parsed.y)}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257"
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>Math.round(value * value)
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "Risposte"
                    }
                },
                yRal: {
                    position: "right",
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>$b711c676d788cd32$var$currency.format(value)
                    },
                    grid: {
                        drawOnChartArea: false
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "RAL (\u20AC)"
                    }
                }
            }
        }
    });
    else if (isReady("rapporto-chart") && hasRapporto && $b711c676d788cd32$var$state.charts.rapporto) {
        $b711c676d788cd32$var$state.charts.rapporto.data.labels = rapportoLabels;
        $b711c676d788cd32$var$state.charts.rapporto.data.datasets[0].data = rapportoCountsCompressed;
        $b711c676d788cd32$var$state.charts.rapporto.data.datasets[0].rawCounts = rapportoCounts;
        $b711c676d788cd32$var$state.charts.rapporto.data.datasets[1].data = rapportoAvg;
        $b711c676d788cd32$var$state.charts.rapporto.data.datasets[2].data = rapportoMedian;
        $b711c676d788cd32$var$state.charts.rapporto.update();
    }
    const modalitaBuckets = {};
    filtered.forEach((row)=>{
        const value = $b711c676d788cd32$var$normalizeValue(row["modalita-lavoro"]);
        if (!value) return;
        const ralValue = $b711c676d788cd32$var$parseRal(row.ral);
        if (!modalitaBuckets[value]) modalitaBuckets[value] = [];
        if (ralValue !== null) modalitaBuckets[value].push(ralValue);
    });
    const modalitaLabels = Object.keys(modalitaBuckets).filter((label)=>modalitaBuckets[label].length >= $b711c676d788cd32$var$MIN_SAMPLE).sort((a, b)=>modalitaBuckets[b].length - modalitaBuckets[a].length);
    const modalitaTrimmed = modalitaLabels.map((label)=>$b711c676d788cd32$var$trimRal(modalitaBuckets[label]));
    const modalitaCounts = modalitaTrimmed.map((values)=>values.length);
    const modalitaCountsCompressed = modalitaCounts.map((value)=>Math.sqrt(value));
    const modalitaAvg = modalitaTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).avg);
    const modalitaMedian = modalitaTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).median);
    const hasModalita = modalitaLabels.length > 0;
    if (isReady("modalita-chart")) {
        $b711c676d788cd32$var$setChartEmpty("modalita-chart", !hasModalita);
        if (!hasModalita) {
            if ($b711c676d788cd32$var$state.charts.modalita) {
                $b711c676d788cd32$var$state.charts.modalita.destroy();
                $b711c676d788cd32$var$state.charts.modalita = null;
            }
        }
    }
    if (isReady("modalita-chart") && hasModalita && !$b711c676d788cd32$var$state.charts.modalita) $b711c676d788cd32$var$state.charts.modalita = new Chart(document.getElementById("modalita-chart"), {
        type: "bar",
        data: {
            labels: modalitaLabels,
            datasets: [
                {
                    label: "Risposte",
                    data: modalitaCountsCompressed,
                    rawCounts: modalitaCounts,
                    backgroundColor: "rgba(255, 99, 132, 0.35)",
                    borderColor: "#ff6384",
                    borderWidth: 1,
                    yAxisID: "y"
                },
                {
                    label: "RAL media",
                    data: modalitaAvg,
                    borderColor: "#0b7a75",
                    backgroundColor: "rgba(11, 122, 117, 0.15)",
                    pointBackgroundColor: "#0b7a75",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                },
                {
                    label: "RAL mediana",
                    data: modalitaMedian,
                    borderColor: "#ff8a00",
                    backgroundColor: "rgba(255, 138, 0, 0.15)",
                    pointBackgroundColor: "#ff8a00",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>{
                            if (context.dataset.label === "Risposte") {
                                const raw = context.dataset.rawCounts?.[context.dataIndex] ?? context.parsed.y;
                                return `Risposte: ${$b711c676d788cd32$var$countFormat.format(raw)}`;
                            }
                            return `${context.dataset.label}: ${$b711c676d788cd32$var$currency.format(context.parsed.y)}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257"
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>Math.round(value * value)
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "Risposte"
                    }
                },
                yRal: {
                    position: "right",
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>$b711c676d788cd32$var$currency.format(value)
                    },
                    grid: {
                        drawOnChartArea: false
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "RAL (\u20AC)"
                    }
                }
            }
        }
    });
    else if (isReady("modalita-chart") && hasModalita && $b711c676d788cd32$var$state.charts.modalita) {
        $b711c676d788cd32$var$state.charts.modalita.data.labels = modalitaLabels;
        $b711c676d788cd32$var$state.charts.modalita.data.datasets[0].data = modalitaCountsCompressed;
        $b711c676d788cd32$var$state.charts.modalita.data.datasets[0].rawCounts = modalitaCounts;
        $b711c676d788cd32$var$state.charts.modalita.data.datasets[1].data = modalitaAvg;
        $b711c676d788cd32$var$state.charts.modalita.data.datasets[2].data = modalitaMedian;
        $b711c676d788cd32$var$state.charts.modalita.update();
    }
    const etaBuckets = {};
    filtered.forEach((row)=>{
        const value = $b711c676d788cd32$var$normalizeValue(row.eta);
        if (!value) return;
        const ralValue = $b711c676d788cd32$var$parseRal(row.ral);
        if (!etaBuckets[value]) etaBuckets[value] = [];
        if (ralValue !== null) etaBuckets[value].push(ralValue);
    });
    const etaLabels = [
        ...$b711c676d788cd32$var$ETA_ORDER.filter((label)=>etaBuckets[label]?.length >= $b711c676d788cd32$var$MIN_SAMPLE),
        ...Object.keys(etaBuckets).filter((label)=>!$b711c676d788cd32$var$ETA_ORDER.includes(label) && etaBuckets[label]?.length >= $b711c676d788cd32$var$MIN_SAMPLE)
    ];
    const etaTrimmed = etaLabels.map((label)=>$b711c676d788cd32$var$trimRal(etaBuckets[label]));
    const etaCounts = etaTrimmed.map((values)=>values.length);
    const etaCountsCompressed = etaCounts.map((value)=>Math.sqrt(value));
    const etaAvg = etaTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).avg);
    const etaMedian = etaTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).median);
    const hasEta = etaLabels.length > 0;
    if (isReady("eta-chart")) {
        $b711c676d788cd32$var$setChartEmpty("eta-chart", !hasEta);
        if (!hasEta) {
            if ($b711c676d788cd32$var$state.charts.eta) {
                $b711c676d788cd32$var$state.charts.eta.destroy();
                $b711c676d788cd32$var$state.charts.eta = null;
            }
        }
    }
    if (isReady("eta-chart") && hasEta && !$b711c676d788cd32$var$state.charts.eta) $b711c676d788cd32$var$state.charts.eta = new Chart(document.getElementById("eta-chart"), {
        type: "bar",
        data: {
            labels: etaLabels,
            datasets: [
                {
                    label: "Risposte",
                    data: etaCountsCompressed,
                    rawCounts: etaCounts,
                    backgroundColor: "rgba(59, 130, 246, 0.35)",
                    borderColor: "#3b82f6",
                    borderWidth: 1,
                    yAxisID: "y"
                },
                {
                    label: "RAL media",
                    data: etaAvg,
                    borderColor: "#0b7a75",
                    backgroundColor: "rgba(11, 122, 117, 0.15)",
                    pointBackgroundColor: "#0b7a75",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                },
                {
                    label: "RAL mediana",
                    data: etaMedian,
                    borderColor: "#ff8a00",
                    backgroundColor: "rgba(255, 138, 0, 0.15)",
                    pointBackgroundColor: "#ff8a00",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>{
                            if (context.dataset.label === "Risposte") {
                                const raw = context.dataset.rawCounts?.[context.dataIndex] ?? context.parsed.y;
                                return `Risposte: ${$b711c676d788cd32$var$countFormat.format(raw)}`;
                            }
                            return `${context.dataset.label}: ${$b711c676d788cd32$var$currency.format(context.parsed.y)}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257"
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>Math.round(value * value)
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "Risposte"
                    }
                },
                yRal: {
                    position: "right",
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>$b711c676d788cd32$var$currency.format(value)
                    },
                    grid: {
                        drawOnChartArea: false
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "RAL (\u20AC)"
                    }
                }
            }
        }
    });
    else if (isReady("eta-chart") && hasEta && $b711c676d788cd32$var$state.charts.eta) {
        $b711c676d788cd32$var$state.charts.eta.data.labels = etaLabels;
        $b711c676d788cd32$var$state.charts.eta.data.datasets[0].data = etaCountsCompressed;
        $b711c676d788cd32$var$state.charts.eta.data.datasets[0].rawCounts = etaCounts;
        $b711c676d788cd32$var$state.charts.eta.data.datasets[1].data = etaAvg;
        $b711c676d788cd32$var$state.charts.eta.data.datasets[2].data = etaMedian;
        $b711c676d788cd32$var$state.charts.eta.update();
    }
    const esperienzaBuckets = {};
    filtered.forEach((row)=>{
        const value = $b711c676d788cd32$var$normalizeValue(row.esperienza);
        if (!value) return;
        const ralValue = $b711c676d788cd32$var$parseRal(row.ral);
        if (!esperienzaBuckets[value]) esperienzaBuckets[value] = [];
        if (ralValue !== null) esperienzaBuckets[value].push(ralValue);
    });
    const esperienzaLabels = [
        ...$b711c676d788cd32$var$ESPERIENZA_ORDER.filter((label)=>esperienzaBuckets[label]?.length >= $b711c676d788cd32$var$MIN_SAMPLE),
        ...Object.keys(esperienzaBuckets).filter((label)=>!$b711c676d788cd32$var$ESPERIENZA_ORDER.includes(label) && esperienzaBuckets[label]?.length >= $b711c676d788cd32$var$MIN_SAMPLE)
    ];
    const esperienzaTrimmed = esperienzaLabels.map((label)=>$b711c676d788cd32$var$trimRal(esperienzaBuckets[label]));
    const esperienzaCounts = esperienzaTrimmed.map((values)=>values.length);
    const esperienzaCountsCompressed = esperienzaCounts.map((value)=>Math.sqrt(value));
    const esperienzaAvg = esperienzaTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).avg);
    const esperienzaMedian = esperienzaTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).median);
    const hasEsperienza = esperienzaLabels.length > 0;
    if (isReady("esperienza-chart")) {
        $b711c676d788cd32$var$setChartEmpty("esperienza-chart", !hasEsperienza);
        if (!hasEsperienza) {
            if ($b711c676d788cd32$var$state.charts.esperienza) {
                $b711c676d788cd32$var$state.charts.esperienza.destroy();
                $b711c676d788cd32$var$state.charts.esperienza = null;
            }
        }
    }
    if (isReady("esperienza-chart") && hasEsperienza && !$b711c676d788cd32$var$state.charts.esperienza) $b711c676d788cd32$var$state.charts.esperienza = new Chart(document.getElementById("esperienza-chart"), {
        type: "bar",
        data: {
            labels: esperienzaLabels,
            datasets: [
                {
                    label: "Risposte",
                    data: esperienzaCountsCompressed,
                    rawCounts: esperienzaCounts,
                    backgroundColor: "rgba(16, 185, 129, 0.35)",
                    borderColor: "#10b981",
                    borderWidth: 1,
                    yAxisID: "y"
                },
                {
                    label: "RAL media",
                    data: esperienzaAvg,
                    borderColor: "#0b7a75",
                    backgroundColor: "rgba(11, 122, 117, 0.15)",
                    pointBackgroundColor: "#0b7a75",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                },
                {
                    label: "RAL mediana",
                    data: esperienzaMedian,
                    borderColor: "#ff8a00",
                    backgroundColor: "rgba(255, 138, 0, 0.15)",
                    pointBackgroundColor: "#ff8a00",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>{
                            if (context.dataset.label === "Risposte") {
                                const raw = context.dataset.rawCounts?.[context.dataIndex] ?? context.parsed.y;
                                return `Risposte: ${$b711c676d788cd32$var$countFormat.format(raw)}`;
                            }
                            return `${context.dataset.label}: ${$b711c676d788cd32$var$currency.format(context.parsed.y)}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257"
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>Math.round(value * value)
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "Risposte"
                    }
                },
                yRal: {
                    position: "right",
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>$b711c676d788cd32$var$currency.format(value)
                    },
                    grid: {
                        drawOnChartArea: false
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "RAL (\u20AC)"
                    }
                }
            }
        }
    });
    else if (isReady("esperienza-chart") && hasEsperienza && $b711c676d788cd32$var$state.charts.esperienza) {
        $b711c676d788cd32$var$state.charts.esperienza.data.labels = esperienzaLabels;
        $b711c676d788cd32$var$state.charts.esperienza.data.datasets[0].data = esperienzaCountsCompressed;
        $b711c676d788cd32$var$state.charts.esperienza.data.datasets[0].rawCounts = esperienzaCounts;
        $b711c676d788cd32$var$state.charts.esperienza.data.datasets[1].data = esperienzaAvg;
        $b711c676d788cd32$var$state.charts.esperienza.data.datasets[2].data = esperienzaMedian;
        $b711c676d788cd32$var$state.charts.esperienza.update();
    }
    const titoloBuckets = {};
    filtered.forEach((row)=>{
        const value = $b711c676d788cd32$var$normalizeValue(row["titolo-studio"]);
        if (!value) return;
        const ralValue = $b711c676d788cd32$var$parseRal(row.ral);
        if (!titoloBuckets[value]) titoloBuckets[value] = [];
        if (ralValue !== null) titoloBuckets[value].push(ralValue);
    });
    const titoloLabels = [
        ...$b711c676d788cd32$var$TITOLO_STUDIO_ORDER.filter((label)=>titoloBuckets[label]?.length >= $b711c676d788cd32$var$MIN_SAMPLE),
        ...Object.keys(titoloBuckets).filter((label)=>!$b711c676d788cd32$var$TITOLO_STUDIO_ORDER.includes(label) && titoloBuckets[label]?.length >= $b711c676d788cd32$var$MIN_SAMPLE)
    ];
    const titoloTrimmed = titoloLabels.map((label)=>$b711c676d788cd32$var$trimRal(titoloBuckets[label]));
    const titoloCounts = titoloTrimmed.map((values)=>values.length);
    const titoloCountsCompressed = titoloCounts.map((value)=>Math.sqrt(value));
    const titoloAvg = titoloTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).avg);
    const titoloMedian = titoloTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).median);
    const hasTitolo = titoloLabels.length > 0;
    if (isReady("titolo-studio-chart")) {
        $b711c676d788cd32$var$setChartEmpty("titolo-studio-chart", !hasTitolo);
        if (!hasTitolo) {
            if ($b711c676d788cd32$var$state.charts.titoloStudio) {
                $b711c676d788cd32$var$state.charts.titoloStudio.destroy();
                $b711c676d788cd32$var$state.charts.titoloStudio = null;
            }
        }
    }
    if (isReady("titolo-studio-chart") && hasTitolo && !$b711c676d788cd32$var$state.charts.titoloStudio) $b711c676d788cd32$var$state.charts.titoloStudio = new Chart(document.getElementById("titolo-studio-chart"), {
        type: "bar",
        data: {
            labels: titoloLabels,
            datasets: [
                {
                    label: "Risposte",
                    data: titoloCountsCompressed,
                    rawCounts: titoloCounts,
                    backgroundColor: "rgba(33, 76, 205, 0.35)",
                    borderColor: "#214ccd",
                    borderWidth: 1,
                    yAxisID: "y"
                },
                {
                    label: "RAL media",
                    data: titoloAvg,
                    borderColor: "#0b7a75",
                    backgroundColor: "rgba(11, 122, 117, 0.15)",
                    pointBackgroundColor: "#0b7a75",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                },
                {
                    label: "RAL mediana",
                    data: titoloMedian,
                    borderColor: "#ff8a00",
                    backgroundColor: "rgba(255, 138, 0, 0.15)",
                    pointBackgroundColor: "#ff8a00",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>{
                            if (context.dataset.label === "Risposte") {
                                const raw = context.dataset.rawCounts?.[context.dataIndex] ?? context.parsed.y;
                                return `Risposte: ${$b711c676d788cd32$var$countFormat.format(raw)}`;
                            }
                            return `${context.dataset.label}: ${$b711c676d788cd32$var$currency.format(context.parsed.y)}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257",
                        maxRotation: 45,
                        minRotation: 45
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>Math.round(value * value)
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "Risposte"
                    }
                },
                yRal: {
                    position: "right",
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>$b711c676d788cd32$var$currency.format(value)
                    },
                    grid: {
                        drawOnChartArea: false
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "RAL (\u20AC)"
                    }
                }
            }
        }
    });
    else if (isReady("titolo-studio-chart") && hasTitolo && $b711c676d788cd32$var$state.charts.titoloStudio) {
        $b711c676d788cd32$var$state.charts.titoloStudio.data.labels = titoloLabels;
        $b711c676d788cd32$var$state.charts.titoloStudio.data.datasets[0].data = titoloCountsCompressed;
        $b711c676d788cd32$var$state.charts.titoloStudio.data.datasets[0].rawCounts = titoloCounts;
        $b711c676d788cd32$var$state.charts.titoloStudio.data.datasets[1].data = titoloAvg;
        $b711c676d788cd32$var$state.charts.titoloStudio.data.datasets[2].data = titoloMedian;
        $b711c676d788cd32$var$state.charts.titoloStudio.update();
    }
    const primoStipendioTitoloBuckets = {};
    filtered.forEach((row)=>{
        const value = $b711c676d788cd32$var$normalizeValue(row["titolo-studio"]);
        if (!value) return;
        const ralValue = $b711c676d788cd32$var$parseRal(row["primo-stipendio"]);
        if (ralValue === null) return;
        if (!primoStipendioTitoloBuckets[value]) primoStipendioTitoloBuckets[value] = [];
        primoStipendioTitoloBuckets[value].push(ralValue);
    });
    const primoTitoloStats = Object.keys(primoStipendioTitoloBuckets).filter((label)=>primoStipendioTitoloBuckets[label].length >= $b711c676d788cd32$var$MIN_SAMPLE).map((label)=>{
        const trimmed = $b711c676d788cd32$var$trimRal(primoStipendioTitoloBuckets[label]);
        const stats = $b711c676d788cd32$var$computeStats(trimmed, false);
        return {
            label: label,
            avg: stats.avg,
            median: stats.median
        };
    }).sort((a, b)=>(a.avg ?? 0) - (b.avg ?? 0));
    const primoTitoloLabels = primoTitoloStats.map((item)=>item.label);
    const primoTitoloAvg = primoTitoloStats.map((item)=>item.avg);
    const primoTitoloMedian = primoTitoloStats.map((item)=>item.median);
    const hasPrimoTitolo = primoTitoloLabels.length > 0;
    if (isReady("primo-stipendio-titolo-chart")) {
        $b711c676d788cd32$var$setChartEmpty("primo-stipendio-titolo-chart", !hasPrimoTitolo);
        if (!hasPrimoTitolo) {
            if ($b711c676d788cd32$var$state.charts.primoTitolo) {
                $b711c676d788cd32$var$state.charts.primoTitolo.destroy();
                $b711c676d788cd32$var$state.charts.primoTitolo = null;
            }
        }
    }
    if (isReady("primo-stipendio-titolo-chart") && hasPrimoTitolo && !$b711c676d788cd32$var$state.charts.primoTitolo) $b711c676d788cd32$var$state.charts.primoTitolo = new Chart(document.getElementById("primo-stipendio-titolo-chart"), {
        type: "bar",
        data: {
            labels: primoTitoloLabels,
            datasets: [
                {
                    label: "RAL media",
                    data: primoTitoloAvg,
                    backgroundColor: "rgba(11, 122, 117, 0.45)",
                    borderColor: "#0b7a75",
                    borderWidth: 1
                },
                {
                    label: "RAL mediana",
                    data: primoTitoloMedian,
                    backgroundColor: "rgba(255, 138, 0, 0.45)",
                    borderColor: "#ff8a00",
                    borderWidth: 1
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>`${context.dataset.label}: ${$b711c676d788cd32$var$currency.format(context.parsed.y)}`
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257",
                        maxRotation: 45,
                        minRotation: 45
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>$b711c676d788cd32$var$currency.format(value)
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "RAL (\u20AC)"
                    }
                }
            }
        }
    });
    else if (isReady("primo-stipendio-titolo-chart") && hasPrimoTitolo && $b711c676d788cd32$var$state.charts.primoTitolo) {
        $b711c676d788cd32$var$state.charts.primoTitolo.data.labels = primoTitoloLabels;
        $b711c676d788cd32$var$state.charts.primoTitolo.data.datasets[0].data = primoTitoloAvg;
        $b711c676d788cd32$var$state.charts.primoTitolo.data.datasets[1].data = primoTitoloMedian;
        $b711c676d788cd32$var$state.charts.primoTitolo.update();
    }
    const titoloBenessere = titoloLabels.map((label)=>{
        const entries = filtered.filter((row)=>$b711c676d788cd32$var$normalizeValue(row["titolo-studio"]) === label);
        const soddisfazioneVals = $b711c676d788cd32$var$trimOutliers(entries.map((row)=>$b711c676d788cd32$var$parseScale(row.soddisfazione)).filter((v)=>v !== null));
        const stressVals = $b711c676d788cd32$var$trimOutliers(entries.map((row)=>$b711c676d788cd32$var$parseScale(row.stress)).filter((v)=>v !== null));
        const crescitaVals = $b711c676d788cd32$var$trimOutliers(entries.map((row)=>$b711c676d788cd32$var$parseScale(row.crescita)).filter((v)=>v !== null));
        return {
            label: label,
            soddisfazione: $b711c676d788cd32$var$computeStats(soddisfazioneVals, false).avg,
            stress: $b711c676d788cd32$var$computeStats(stressVals, false).avg,
            crescita: $b711c676d788cd32$var$computeStats(crescitaVals, false).avg
        };
    });
    const titoloBenessereLabels = titoloBenessere.map((item)=>item.label);
    const soddisfazioneTitolo = titoloBenessere.map((item)=>$b711c676d788cd32$var$scaleToPercent(item.soddisfazione));
    const stressTitolo = titoloBenessere.map((item)=>$b711c676d788cd32$var$scaleToPercent(item.stress));
    const crescitaTitolo = titoloBenessere.map((item)=>$b711c676d788cd32$var$scaleToPercent(item.crescita));
    const hasTitoloBenessere = titoloBenessereLabels.length > 0;
    if (isReady("titolo-benessere-chart")) {
        $b711c676d788cd32$var$setChartEmpty("titolo-benessere-chart", !hasTitoloBenessere);
        if (!hasTitoloBenessere) {
            if ($b711c676d788cd32$var$state.charts.titoloBenessere) {
                $b711c676d788cd32$var$state.charts.titoloBenessere.destroy();
                $b711c676d788cd32$var$state.charts.titoloBenessere = null;
            }
        }
    }
    if (isReady("titolo-benessere-chart") && hasTitoloBenessere && !$b711c676d788cd32$var$state.charts.titoloBenessere) $b711c676d788cd32$var$state.charts.titoloBenessere = new Chart(document.getElementById("titolo-benessere-chart"), {
        type: "bar",
        data: {
            labels: titoloBenessereLabels,
            datasets: [
                {
                    label: "Soddisfazione",
                    data: soddisfazioneTitolo,
                    backgroundColor: "rgba(11, 122, 117, 0.55)",
                    borderColor: "#0b7a75",
                    borderWidth: 1
                },
                {
                    label: "Stress",
                    data: stressTitolo,
                    backgroundColor: "rgba(239, 68, 68, 0.55)",
                    borderColor: "#ef4444",
                    borderWidth: 1
                },
                {
                    label: "Prospettive di crescita",
                    data: crescitaTitolo,
                    backgroundColor: "rgba(245, 158, 11, 0.55)",
                    borderColor: "#f59e0b",
                    borderWidth: 1
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>`${context.dataset.label}: ${$b711c676d788cd32$var$numberFormat.format(context.parsed.y)}%`
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257",
                        maxRotation: 45,
                        minRotation: 45,
                        autoSkip: false
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>`${$b711c676d788cd32$var$numberFormat.format(value)}%`
                    },
                    beginAtZero: true,
                    max: 100,
                    title: {
                        display: true,
                        text: "Percentuale"
                    }
                }
            }
        }
    });
    else if (isReady("titolo-benessere-chart") && hasTitoloBenessere && $b711c676d788cd32$var$state.charts.titoloBenessere) {
        $b711c676d788cd32$var$state.charts.titoloBenessere.data.labels = titoloBenessereLabels;
        $b711c676d788cd32$var$state.charts.titoloBenessere.data.datasets[0].data = soddisfazioneTitolo;
        $b711c676d788cd32$var$state.charts.titoloBenessere.data.datasets[1].data = stressTitolo;
        $b711c676d788cd32$var$state.charts.titoloBenessere.data.datasets[2].data = crescitaTitolo;
        $b711c676d788cd32$var$state.charts.titoloBenessere.update();
    }
    const ambitoStudioBuckets = {};
    filtered.forEach((row)=>{
        const value = $b711c676d788cd32$var$normalizeValue(row["ambito-studio"]);
        if (!value) return;
        const ralValue = $b711c676d788cd32$var$parseRal(row.ral);
        if (!ambitoStudioBuckets[value]) ambitoStudioBuckets[value] = [];
        if (ralValue !== null) ambitoStudioBuckets[value].push(ralValue);
    });
    const ambitoStudioStats = Object.keys(ambitoStudioBuckets).filter((label)=>ambitoStudioBuckets[label].length >= $b711c676d788cd32$var$MIN_SAMPLE).map((label)=>{
        const trimmed = $b711c676d788cd32$var$trimRal(ambitoStudioBuckets[label]);
        const stats = $b711c676d788cd32$var$computeStats(trimmed, false);
        return {
            label: label,
            count: trimmed.length,
            avg: stats.avg,
            median: stats.median
        };
    }).sort((a, b)=>(a.avg ?? 0) - (b.avg ?? 0));
    const ambitoStudioLabels = ambitoStudioStats.map((item)=>item.label);
    const ambitoStudioCounts = ambitoStudioStats.map((item)=>item.count);
    const ambitoStudioCountsCompressed = ambitoStudioCounts.map((value)=>Math.sqrt(value));
    const ambitoStudioAvg = ambitoStudioStats.map((item)=>item.avg);
    const ambitoStudioMedian = ambitoStudioStats.map((item)=>item.median);
    const hasAmbitoStudio = ambitoStudioLabels.length > 0;
    if (isReady("ambito-studio-chart")) {
        $b711c676d788cd32$var$setChartEmpty("ambito-studio-chart", !hasAmbitoStudio);
        if (!hasAmbitoStudio) {
            if ($b711c676d788cd32$var$state.charts.ambitoStudio) {
                $b711c676d788cd32$var$state.charts.ambitoStudio.destroy();
                $b711c676d788cd32$var$state.charts.ambitoStudio = null;
            }
        }
    }
    if (isReady("ambito-studio-chart") && hasAmbitoStudio && !$b711c676d788cd32$var$state.charts.ambitoStudio) $b711c676d788cd32$var$state.charts.ambitoStudio = new Chart(document.getElementById("ambito-studio-chart"), {
        type: "bar",
        data: {
            labels: ambitoStudioLabels,
            datasets: [
                {
                    label: "Risposte",
                    data: ambitoStudioCountsCompressed,
                    rawCounts: ambitoStudioCounts,
                    backgroundColor: "rgba(59, 130, 246, 0.35)",
                    borderColor: "#3b82f6",
                    borderWidth: 1,
                    yAxisID: "y"
                },
                {
                    label: "RAL media",
                    data: ambitoStudioAvg,
                    borderColor: "#0b7a75",
                    backgroundColor: "rgba(11, 122, 117, 0.15)",
                    pointBackgroundColor: "#0b7a75",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                },
                {
                    label: "RAL mediana",
                    data: ambitoStudioMedian,
                    borderColor: "#ff8a00",
                    backgroundColor: "rgba(255, 138, 0, 0.15)",
                    pointBackgroundColor: "#ff8a00",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>{
                            if (context.dataset.label === "Risposte") {
                                const raw = context.dataset.rawCounts?.[context.dataIndex] ?? context.parsed.y;
                                return `Risposte: ${$b711c676d788cd32$var$countFormat.format(raw)}`;
                            }
                            return `${context.dataset.label}: ${$b711c676d788cd32$var$currency.format(context.parsed.y)}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257",
                        maxRotation: 45,
                        minRotation: 45
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>Math.round(value * value)
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "Risposte"
                    }
                },
                yRal: {
                    position: "right",
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>$b711c676d788cd32$var$currency.format(value)
                    },
                    grid: {
                        drawOnChartArea: false
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "RAL (\u20AC)"
                    }
                }
            }
        }
    });
    else if (isReady("ambito-studio-chart") && hasAmbitoStudio && $b711c676d788cd32$var$state.charts.ambitoStudio) {
        $b711c676d788cd32$var$state.charts.ambitoStudio.data.labels = ambitoStudioLabels;
        $b711c676d788cd32$var$state.charts.ambitoStudio.data.datasets[0].data = ambitoStudioCountsCompressed;
        $b711c676d788cd32$var$state.charts.ambitoStudio.data.datasets[0].rawCounts = ambitoStudioCounts;
        $b711c676d788cd32$var$state.charts.ambitoStudio.data.datasets[1].data = ambitoStudioAvg;
        $b711c676d788cd32$var$state.charts.ambitoStudio.data.datasets[2].data = ambitoStudioMedian;
        $b711c676d788cd32$var$state.charts.ambitoStudio.update();
    }
    const primoStipendioBuckets = {};
    filtered.forEach((row)=>{
        const value = $b711c676d788cd32$var$normalizeValue(row["ambito-studio"]);
        if (!value) return;
        const ralValue = $b711c676d788cd32$var$parseRal(row["primo-stipendio"]);
        if (ralValue === null) return;
        if (!primoStipendioBuckets[value]) primoStipendioBuckets[value] = [];
        primoStipendioBuckets[value].push(ralValue);
    });
    const primoStipendioStats = Object.keys(primoStipendioBuckets).filter((label)=>primoStipendioBuckets[label].length >= $b711c676d788cd32$var$MIN_SAMPLE).map((label)=>{
        const trimmed = $b711c676d788cd32$var$trimRal(primoStipendioBuckets[label]);
        const stats = $b711c676d788cd32$var$computeStats(trimmed, false);
        return {
            label: label,
            avg: stats.avg,
            median: stats.median
        };
    }).sort((a, b)=>(a.avg ?? 0) - (b.avg ?? 0));
    const primoStipendioLabels = primoStipendioStats.map((item)=>item.label);
    const primoStipendioAvg = primoStipendioStats.map((item)=>item.avg);
    const primoStipendioMedian = primoStipendioStats.map((item)=>item.median);
    const hasPrimoStipendio = primoStipendioLabels.length > 0;
    if (isReady("primo-stipendio-chart")) {
        $b711c676d788cd32$var$setChartEmpty("primo-stipendio-chart", !hasPrimoStipendio);
        if (!hasPrimoStipendio) {
            if ($b711c676d788cd32$var$state.charts.primoStipendio) {
                $b711c676d788cd32$var$state.charts.primoStipendio.destroy();
                $b711c676d788cd32$var$state.charts.primoStipendio = null;
            }
        }
    }
    if (isReady("primo-stipendio-chart") && hasPrimoStipendio && !$b711c676d788cd32$var$state.charts.primoStipendio) $b711c676d788cd32$var$state.charts.primoStipendio = new Chart(document.getElementById("primo-stipendio-chart"), {
        type: "bar",
        data: {
            labels: primoStipendioLabels,
            datasets: [
                {
                    label: "RAL media",
                    data: primoStipendioAvg,
                    backgroundColor: "rgba(11, 122, 117, 0.45)",
                    borderColor: "#0b7a75",
                    borderWidth: 1
                },
                {
                    label: "RAL mediana",
                    data: primoStipendioMedian,
                    backgroundColor: "rgba(255, 138, 0, 0.45)",
                    borderColor: "#ff8a00",
                    borderWidth: 1
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>`${context.dataset.label}: ${$b711c676d788cd32$var$currency.format(context.parsed.y)}`
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257",
                        maxRotation: 45,
                        minRotation: 45
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>$b711c676d788cd32$var$currency.format(value)
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "RAL (\u20AC)"
                    }
                }
            }
        }
    });
    else if (isReady("primo-stipendio-chart") && hasPrimoStipendio && $b711c676d788cd32$var$state.charts.primoStipendio) {
        $b711c676d788cd32$var$state.charts.primoStipendio.data.labels = primoStipendioLabels;
        $b711c676d788cd32$var$state.charts.primoStipendio.data.datasets[0].data = primoStipendioAvg;
        $b711c676d788cd32$var$state.charts.primoStipendio.data.datasets[1].data = primoStipendioMedian;
        $b711c676d788cd32$var$state.charts.primoStipendio.update();
    }
    const livelloBuckets = {};
    filtered.forEach((row)=>{
        const value = $b711c676d788cd32$var$normalizeValue(row.livello);
        if (!value) return;
        const ralValue = $b711c676d788cd32$var$parseRal(row.ral);
        if (!livelloBuckets[value]) livelloBuckets[value] = [];
        if (ralValue !== null) livelloBuckets[value].push(ralValue);
    });
    const livelloLabels = [
        ...$b711c676d788cd32$var$LIVELLO_ORDER.filter((label)=>livelloBuckets[label]?.length >= $b711c676d788cd32$var$MIN_SAMPLE),
        ...Object.keys(livelloBuckets).filter((label)=>!$b711c676d788cd32$var$LIVELLO_ORDER.includes(label) && livelloBuckets[label]?.length >= $b711c676d788cd32$var$MIN_SAMPLE)
    ];
    if (livelloLabels.length) {
        const livelloDebug = livelloLabels.map((label)=>{
            const stats = $b711c676d788cd32$var$computeStats(livelloBuckets[label] || []);
            return {
                livello: label,
                count: livelloBuckets[label]?.length || 0,
                avg: stats.avg,
                median: stats.median
            };
        });
        console.table(livelloDebug);
    }
    const livelloTrimmed = livelloLabels.map((label)=>$b711c676d788cd32$var$trimRal(livelloBuckets[label]));
    const livelloCounts = livelloTrimmed.map((values)=>values.length);
    const livelloCountsCompressed = livelloCounts.map((value)=>Math.sqrt(value));
    const livelloAvg = livelloTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).avg);
    const livelloMedian = livelloTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).median);
    const hasLivello = livelloLabels.length > 0;
    if (isReady("livello-chart")) {
        $b711c676d788cd32$var$setChartEmpty("livello-chart", !hasLivello);
        if (!hasLivello) {
            if ($b711c676d788cd32$var$state.charts.livello) {
                $b711c676d788cd32$var$state.charts.livello.destroy();
                $b711c676d788cd32$var$state.charts.livello = null;
            }
        }
    }
    if (isReady("livello-chart") && hasLivello && !$b711c676d788cd32$var$state.charts.livello) $b711c676d788cd32$var$state.charts.livello = new Chart(document.getElementById("livello-chart"), {
        type: "bar",
        data: {
            labels: livelloLabels,
            datasets: [
                {
                    label: "Risposte",
                    data: livelloCountsCompressed,
                    rawCounts: livelloCounts,
                    backgroundColor: "rgba(153, 102, 255, 0.35)",
                    borderColor: "#9966ff",
                    borderWidth: 1,
                    yAxisID: "y"
                },
                {
                    label: "RAL media",
                    data: livelloAvg,
                    borderColor: "#0b7a75",
                    backgroundColor: "rgba(11, 122, 117, 0.15)",
                    pointBackgroundColor: "#0b7a75",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                },
                {
                    label: "RAL mediana",
                    data: livelloMedian,
                    borderColor: "#ff8a00",
                    backgroundColor: "rgba(255, 138, 0, 0.15)",
                    pointBackgroundColor: "#ff8a00",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>{
                            if (context.dataset.label === "Risposte") {
                                const raw = context.dataset.rawCounts?.[context.dataIndex] ?? context.parsed.y;
                                return `Risposte: ${$b711c676d788cd32$var$countFormat.format(raw)}`;
                            }
                            return `${context.dataset.label}: ${$b711c676d788cd32$var$currency.format(context.parsed.y)}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257"
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>Math.round(value * value)
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "Risposte"
                    }
                },
                yRal: {
                    position: "right",
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>$b711c676d788cd32$var$currency.format(value)
                    },
                    grid: {
                        drawOnChartArea: false
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "RAL (\u20AC)"
                    }
                }
            }
        }
    });
    else if (isReady("livello-chart") && hasLivello && $b711c676d788cd32$var$state.charts.livello) {
        $b711c676d788cd32$var$state.charts.livello.data.labels = livelloLabels;
        $b711c676d788cd32$var$state.charts.livello.data.datasets[0].data = livelloCountsCompressed;
        $b711c676d788cd32$var$state.charts.livello.data.datasets[0].rawCounts = livelloCounts;
        $b711c676d788cd32$var$state.charts.livello.data.datasets[1].data = livelloAvg;
        $b711c676d788cd32$var$state.charts.livello.data.datasets[2].data = livelloMedian;
        $b711c676d788cd32$var$state.charts.livello.update();
    }
    const dimensioneBuckets = {};
    filtered.forEach((row)=>{
        const value = $b711c676d788cd32$var$normalizeValue(row.dimensione);
        if (!value) return;
        const ralValue = $b711c676d788cd32$var$parseRal(row.ral);
        if (!dimensioneBuckets[value]) dimensioneBuckets[value] = [];
        if (ralValue !== null) dimensioneBuckets[value].push(ralValue);
    });
    const dimensioneLabels = [
        ...$b711c676d788cd32$var$DIMENSIONE_ORDER.filter((label)=>dimensioneBuckets[label]?.length >= $b711c676d788cd32$var$MIN_SAMPLE),
        ...Object.keys(dimensioneBuckets).filter((label)=>!$b711c676d788cd32$var$DIMENSIONE_ORDER.includes(label) && dimensioneBuckets[label]?.length >= $b711c676d788cd32$var$MIN_SAMPLE)
    ];
    const dimensioneTrimmed = dimensioneLabels.map((label)=>$b711c676d788cd32$var$trimRal(dimensioneBuckets[label]));
    const dimensioneCounts = dimensioneTrimmed.map((values)=>values.length);
    const dimensioneCountsCompressed = dimensioneCounts.map((value)=>Math.sqrt(value));
    const dimensioneAvg = dimensioneTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).avg);
    const dimensioneMedian = dimensioneTrimmed.map((values)=>$b711c676d788cd32$var$computeStats(values, false).median);
    const hasDimensione = dimensioneLabels.length > 0;
    if (isReady("dimensione-chart")) {
        $b711c676d788cd32$var$setChartEmpty("dimensione-chart", !hasDimensione);
        if (!hasDimensione) {
            if ($b711c676d788cd32$var$state.charts.dimensione) {
                $b711c676d788cd32$var$state.charts.dimensione.destroy();
                $b711c676d788cd32$var$state.charts.dimensione = null;
            }
        }
    }
    if (isReady("dimensione-chart") && hasDimensione && !$b711c676d788cd32$var$state.charts.dimensione) $b711c676d788cd32$var$state.charts.dimensione = new Chart(document.getElementById("dimensione-chart"), {
        type: "bar",
        data: {
            labels: dimensioneLabels,
            datasets: [
                {
                    label: "Risposte",
                    data: dimensioneCountsCompressed,
                    rawCounts: dimensioneCounts,
                    backgroundColor: "rgba(59, 130, 246, 0.35)",
                    borderColor: "#3b82f6",
                    borderWidth: 1,
                    yAxisID: "y"
                },
                {
                    label: "RAL media",
                    data: dimensioneAvg,
                    borderColor: "#0b7a75",
                    backgroundColor: "rgba(11, 122, 117, 0.15)",
                    pointBackgroundColor: "#0b7a75",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                },
                {
                    label: "RAL mediana",
                    data: dimensioneMedian,
                    borderColor: "#ff8a00",
                    backgroundColor: "rgba(255, 138, 0, 0.15)",
                    pointBackgroundColor: "#ff8a00",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>{
                            if (context.dataset.label === "Risposte") {
                                const raw = context.dataset.rawCounts?.[context.dataIndex] ?? context.parsed.y;
                                return `Risposte: ${$b711c676d788cd32$var$countFormat.format(raw)}`;
                            }
                            return `${context.dataset.label}: ${$b711c676d788cd32$var$currency.format(context.parsed.y)}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257"
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>Math.round(value * value)
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "Risposte"
                    }
                },
                yRal: {
                    position: "right",
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>$b711c676d788cd32$var$currency.format(value)
                    },
                    grid: {
                        drawOnChartArea: false
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "RAL (\u20AC)"
                    }
                }
            }
        }
    });
    else if (isReady("dimensione-chart") && hasDimensione && $b711c676d788cd32$var$state.charts.dimensione) {
        $b711c676d788cd32$var$state.charts.dimensione.data.labels = dimensioneLabels;
        $b711c676d788cd32$var$state.charts.dimensione.data.datasets[0].data = dimensioneCountsCompressed;
        $b711c676d788cd32$var$state.charts.dimensione.data.datasets[0].rawCounts = dimensioneCounts;
        $b711c676d788cd32$var$state.charts.dimensione.data.datasets[1].data = dimensioneAvg;
        $b711c676d788cd32$var$state.charts.dimensione.data.datasets[2].data = dimensioneMedian;
        $b711c676d788cd32$var$state.charts.dimensione.update();
    }
    const settoreBuckets = {};
    filtered.forEach((row)=>{
        const value = $b711c676d788cd32$var$normalizeValue(row.settore);
        if (!value) return;
        const ralValue = $b711c676d788cd32$var$parseRal(row.ral);
        if (!settoreBuckets[value]) settoreBuckets[value] = [];
        if (ralValue !== null) settoreBuckets[value].push(ralValue);
    });
    const settoreStats = Object.keys(settoreBuckets).filter((label)=>settoreBuckets[label].length >= $b711c676d788cd32$var$MIN_SAMPLE).map((label)=>{
        const trimmed = $b711c676d788cd32$var$trimRal(settoreBuckets[label]);
        const stats = $b711c676d788cd32$var$computeStats(trimmed, false);
        return {
            label: label,
            count: trimmed.length,
            avg: stats.avg,
            median: stats.median
        };
    }).sort((a, b)=>(a.avg ?? 0) - (b.avg ?? 0));
    const settoreLabels = settoreStats.map((item)=>item.label);
    const settoreCounts = settoreStats.map((item)=>item.count);
    const settoreCountsCompressed = settoreCounts.map((value)=>Math.sqrt(value));
    const settoreAvg = settoreStats.map((item)=>item.avg);
    const settoreMedian = settoreStats.map((item)=>item.median);
    const hasSettore = settoreLabels.length > 0;
    if (isReady("settore-chart")) {
        $b711c676d788cd32$var$setChartEmpty("settore-chart", !hasSettore);
        if (!hasSettore) {
            if ($b711c676d788cd32$var$state.charts.settore) {
                $b711c676d788cd32$var$state.charts.settore.destroy();
                $b711c676d788cd32$var$state.charts.settore = null;
            }
        }
    }
    if (isReady("settore-chart") && hasSettore && !$b711c676d788cd32$var$state.charts.settore) $b711c676d788cd32$var$state.charts.settore = new Chart(document.getElementById("settore-chart"), {
        type: "bar",
        data: {
            labels: settoreLabels,
            datasets: [
                {
                    label: "Risposte",
                    data: settoreCountsCompressed,
                    rawCounts: settoreCounts,
                    backgroundColor: "rgba(255, 159, 64, 0.35)",
                    borderColor: "#ff9f40",
                    borderWidth: 1,
                    yAxisID: "y"
                },
                {
                    label: "RAL media",
                    data: settoreAvg,
                    borderColor: "#0b7a75",
                    backgroundColor: "rgba(11, 122, 117, 0.15)",
                    pointBackgroundColor: "#0b7a75",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                },
                {
                    label: "RAL mediana",
                    data: settoreMedian,
                    borderColor: "#ff8a00",
                    backgroundColor: "rgba(255, 138, 0, 0.15)",
                    pointBackgroundColor: "#ff8a00",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>{
                            if (context.dataset.label === "Risposte") {
                                const raw = context.dataset.rawCounts?.[context.dataIndex] ?? context.parsed.y;
                                return `Risposte: ${$b711c676d788cd32$var$countFormat.format(raw)}`;
                            }
                            return `${context.dataset.label}: ${$b711c676d788cd32$var$currency.format(context.parsed.y)}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257",
                        autoSkip: false,
                        maxRotation: 45,
                        minRotation: 45
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>Math.round(value * value)
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "Risposte"
                    }
                },
                yRal: {
                    position: "right",
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>$b711c676d788cd32$var$currency.format(value)
                    },
                    grid: {
                        drawOnChartArea: false
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "RAL (\u20AC)"
                    }
                }
            }
        }
    });
    else if (isReady("settore-chart") && hasSettore && $b711c676d788cd32$var$state.charts.settore) {
        $b711c676d788cd32$var$state.charts.settore.data.labels = settoreLabels;
        $b711c676d788cd32$var$state.charts.settore.data.datasets[0].data = settoreCountsCompressed;
        $b711c676d788cd32$var$state.charts.settore.data.datasets[0].rawCounts = settoreCounts;
        $b711c676d788cd32$var$state.charts.settore.data.datasets[1].data = settoreAvg;
        $b711c676d788cd32$var$state.charts.settore.data.datasets[2].data = settoreMedian;
        $b711c676d788cd32$var$state.charts.settore.update();
    }
    const settoreBenessere = settoreStats.map((item)=>{
        const entries = filtered.filter((row)=>$b711c676d788cd32$var$normalizeValue(row.settore) === item.label);
        const soddisfazioneVals = $b711c676d788cd32$var$trimOutliers(entries.map((row)=>$b711c676d788cd32$var$parseScale(row.soddisfazione)).filter((v)=>v !== null));
        const stressVals = $b711c676d788cd32$var$trimOutliers(entries.map((row)=>$b711c676d788cd32$var$parseScale(row.stress)).filter((v)=>v !== null));
        const crescitaVals = $b711c676d788cd32$var$trimOutliers(entries.map((row)=>$b711c676d788cd32$var$parseScale(row.crescita)).filter((v)=>v !== null));
        return {
            label: item.label,
            soddisfazione: $b711c676d788cd32$var$computeStats(soddisfazioneVals, false).avg,
            stress: $b711c676d788cd32$var$computeStats(stressVals, false).avg,
            crescita: $b711c676d788cd32$var$computeStats(crescitaVals, false).avg
        };
    });
    const settoreBenessereLabels = settoreBenessere.map((item)=>item.label);
    const soddisfazioneSeries = settoreBenessere.map((item)=>$b711c676d788cd32$var$scaleToPercent(item.soddisfazione));
    const stressSeries = settoreBenessere.map((item)=>$b711c676d788cd32$var$scaleToPercent(item.stress));
    const crescitaSeries = settoreBenessere.map((item)=>$b711c676d788cd32$var$scaleToPercent(item.crescita));
    const hasSettoreBenessere = settoreBenessereLabels.length > 0;
    if (isReady("settore-benessere-chart")) {
        $b711c676d788cd32$var$setChartEmpty("settore-benessere-chart", !hasSettoreBenessere);
        if (!hasSettoreBenessere) {
            if ($b711c676d788cd32$var$state.charts.settoreBenessere) {
                $b711c676d788cd32$var$state.charts.settoreBenessere.destroy();
                $b711c676d788cd32$var$state.charts.settoreBenessere = null;
            }
        }
    }
    if (isReady("settore-benessere-chart") && hasSettoreBenessere && !$b711c676d788cd32$var$state.charts.settoreBenessere) $b711c676d788cd32$var$state.charts.settoreBenessere = new Chart(document.getElementById("settore-benessere-chart"), {
        type: "bar",
        data: {
            labels: settoreBenessereLabels,
            datasets: [
                {
                    label: "Soddisfazione",
                    data: soddisfazioneSeries,
                    backgroundColor: "rgba(11, 122, 117, 0.55)",
                    borderColor: "#0b7a75",
                    borderWidth: 1
                },
                {
                    label: "Stress",
                    data: stressSeries,
                    backgroundColor: "rgba(239, 68, 68, 0.55)",
                    borderColor: "#ef4444",
                    borderWidth: 1
                },
                {
                    label: "Prospettive di crescita",
                    data: crescitaSeries,
                    backgroundColor: "rgba(245, 158, 11, 0.55)",
                    borderColor: "#f59e0b",
                    borderWidth: 1
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>`${context.dataset.label}: ${$b711c676d788cd32$var$numberFormat.format(context.parsed.y)}%`
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257",
                        maxRotation: 45,
                        minRotation: 45,
                        autoSkip: false
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>`${$b711c676d788cd32$var$numberFormat.format(value)}%`
                    },
                    beginAtZero: true,
                    max: 100,
                    title: {
                        display: true,
                        text: "Percentuale"
                    }
                }
            }
        }
    });
    else if (isReady("settore-benessere-chart") && hasSettoreBenessere && $b711c676d788cd32$var$state.charts.settoreBenessere) {
        $b711c676d788cd32$var$state.charts.settoreBenessere.data.labels = settoreBenessereLabels;
        $b711c676d788cd32$var$state.charts.settoreBenessere.data.datasets[0].data = soddisfazioneSeries;
        $b711c676d788cd32$var$state.charts.settoreBenessere.data.datasets[1].data = stressSeries;
        $b711c676d788cd32$var$state.charts.settoreBenessere.data.datasets[2].data = crescitaSeries;
        $b711c676d788cd32$var$state.charts.settoreBenessere.update();
    }
    const ambitoBuckets = {};
    filtered.forEach((row)=>{
        const value = $b711c676d788cd32$var$normalizeValue(row.ambito);
        if (!value) return;
        const ralValue = $b711c676d788cd32$var$parseRal(row.ral);
        if (!ambitoBuckets[value]) ambitoBuckets[value] = [];
        if (ralValue !== null) ambitoBuckets[value].push(ralValue);
    });
    const ambitoStats = Object.keys(ambitoBuckets).filter((label)=>ambitoBuckets[label].length >= $b711c676d788cd32$var$MIN_SAMPLE).map((label)=>{
        const trimmed = $b711c676d788cd32$var$trimRal(ambitoBuckets[label]);
        const stats = $b711c676d788cd32$var$computeStats(trimmed, false);
        return {
            label: label,
            count: trimmed.length,
            avg: stats.avg,
            median: stats.median
        };
    }).sort((a, b)=>(a.avg ?? 0) - (b.avg ?? 0));
    const ambitoLabels = ambitoStats.map((item)=>item.label);
    const ambitoCounts = ambitoStats.map((item)=>item.count);
    const ambitoCountsCompressed = ambitoCounts.map((value)=>Math.sqrt(value));
    const ambitoAvg = ambitoStats.map((item)=>item.avg);
    const ambitoMedian = ambitoStats.map((item)=>item.median);
    const hasAmbito = ambitoLabels.length > 0;
    if (isReady("ambito-chart")) {
        $b711c676d788cd32$var$setChartEmpty("ambito-chart", !hasAmbito);
        if (!hasAmbito) {
            if ($b711c676d788cd32$var$state.charts.ambito) {
                $b711c676d788cd32$var$state.charts.ambito.destroy();
                $b711c676d788cd32$var$state.charts.ambito = null;
            }
        }
    }
    if (isReady("ambito-chart") && hasAmbito && !$b711c676d788cd32$var$state.charts.ambito) $b711c676d788cd32$var$state.charts.ambito = new Chart(document.getElementById("ambito-chart"), {
        type: "bar",
        data: {
            labels: ambitoLabels,
            datasets: [
                {
                    label: "Risposte",
                    data: ambitoCountsCompressed,
                    rawCounts: ambitoCounts,
                    backgroundColor: "rgba(79, 70, 229, 0.35)",
                    borderColor: "#4f46e5",
                    borderWidth: 1,
                    yAxisID: "y"
                },
                {
                    label: "RAL media",
                    data: ambitoAvg,
                    borderColor: "#0b7a75",
                    backgroundColor: "rgba(11, 122, 117, 0.15)",
                    pointBackgroundColor: "#0b7a75",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                },
                {
                    label: "RAL mediana",
                    data: ambitoMedian,
                    borderColor: "#ff8a00",
                    backgroundColor: "rgba(255, 138, 0, 0.15)",
                    pointBackgroundColor: "#ff8a00",
                    borderWidth: 2,
                    tension: 0.3,
                    type: "line",
                    yAxisID: "yRal"
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>{
                            if (context.dataset.label === "Risposte") {
                                const raw = context.dataset.rawCounts?.[context.dataIndex] ?? context.parsed.y;
                                return `Risposte: ${$b711c676d788cd32$var$countFormat.format(raw)}`;
                            }
                            return `${context.dataset.label}: ${$b711c676d788cd32$var$currency.format(context.parsed.y)}`;
                        }
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257",
                        maxRotation: 45,
                        minRotation: 45
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>Math.round(value * value)
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "Risposte"
                    }
                },
                yRal: {
                    position: "right",
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>$b711c676d788cd32$var$currency.format(value)
                    },
                    grid: {
                        drawOnChartArea: false
                    },
                    beginAtZero: true,
                    title: {
                        display: true,
                        text: "RAL (\u20AC)"
                    }
                }
            }
        }
    });
    else if (isReady("ambito-chart") && hasAmbito && $b711c676d788cd32$var$state.charts.ambito) {
        $b711c676d788cd32$var$state.charts.ambito.data.labels = ambitoLabels;
        $b711c676d788cd32$var$state.charts.ambito.data.datasets[0].data = ambitoCountsCompressed;
        $b711c676d788cd32$var$state.charts.ambito.data.datasets[0].rawCounts = ambitoCounts;
        $b711c676d788cd32$var$state.charts.ambito.data.datasets[1].data = ambitoAvg;
        $b711c676d788cd32$var$state.charts.ambito.data.datasets[2].data = ambitoMedian;
        $b711c676d788cd32$var$state.charts.ambito.update();
    }
    const ambitoBenessere = ambitoStats.map((item)=>{
        const entries = filtered.filter((row)=>$b711c676d788cd32$var$normalizeValue(row.ambito) === item.label);
        const soddisfazioneVals = $b711c676d788cd32$var$trimOutliers(entries.map((row)=>$b711c676d788cd32$var$parseScale(row.soddisfazione)).filter((v)=>v !== null));
        const stressVals = $b711c676d788cd32$var$trimOutliers(entries.map((row)=>$b711c676d788cd32$var$parseScale(row.stress)).filter((v)=>v !== null));
        const crescitaVals = $b711c676d788cd32$var$trimOutliers(entries.map((row)=>$b711c676d788cd32$var$parseScale(row.crescita)).filter((v)=>v !== null));
        return {
            label: item.label,
            soddisfazione: $b711c676d788cd32$var$computeStats(soddisfazioneVals, false).avg,
            stress: $b711c676d788cd32$var$computeStats(stressVals, false).avg,
            crescita: $b711c676d788cd32$var$computeStats(crescitaVals, false).avg
        };
    });
    const ambitoBenessereLabels = ambitoBenessere.map((item)=>item.label);
    const soddisfazioneAmbito = ambitoBenessere.map((item)=>$b711c676d788cd32$var$scaleToPercent(item.soddisfazione));
    const stressAmbito = ambitoBenessere.map((item)=>$b711c676d788cd32$var$scaleToPercent(item.stress));
    const crescitaAmbito = ambitoBenessere.map((item)=>$b711c676d788cd32$var$scaleToPercent(item.crescita));
    const hasAmbitoBenessere = ambitoBenessereLabels.length > 0;
    if (isReady("ambito-benessere-chart")) {
        $b711c676d788cd32$var$setChartEmpty("ambito-benessere-chart", !hasAmbitoBenessere);
        if (!hasAmbitoBenessere) {
            if ($b711c676d788cd32$var$state.charts.ambitoBenessere) {
                $b711c676d788cd32$var$state.charts.ambitoBenessere.destroy();
                $b711c676d788cd32$var$state.charts.ambitoBenessere = null;
            }
        }
    }
    if (isReady("ambito-benessere-chart") && hasAmbitoBenessere && !$b711c676d788cd32$var$state.charts.ambitoBenessere) $b711c676d788cd32$var$state.charts.ambitoBenessere = new Chart(document.getElementById("ambito-benessere-chart"), {
        type: "bar",
        data: {
            labels: ambitoBenessereLabels,
            datasets: [
                {
                    label: "Soddisfazione",
                    data: soddisfazioneAmbito,
                    backgroundColor: "rgba(11, 122, 117, 0.55)",
                    borderColor: "#0b7a75",
                    borderWidth: 1
                },
                {
                    label: "Stress",
                    data: stressAmbito,
                    backgroundColor: "rgba(239, 68, 68, 0.55)",
                    borderColor: "#ef4444",
                    borderWidth: 1
                },
                {
                    label: "Prospettive di crescita",
                    data: crescitaAmbito,
                    backgroundColor: "rgba(245, 158, 11, 0.55)",
                    borderColor: "#f59e0b",
                    borderWidth: 1
                }
            ]
        },
        options: {
            responsive: true,
            plugins: {
                legend: {
                    display: true
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>`${context.dataset.label}: ${$b711c676d788cd32$var$numberFormat.format(context.parsed.y)}%`
                    }
                }
            },
            scales: {
                x: {
                    ticks: {
                        color: "#6b6257",
                        maxRotation: 45,
                        minRotation: 45,
                        autoSkip: false
                    }
                },
                y: {
                    ticks: {
                        color: "#6b6257",
                        callback: (value)=>`${$b711c676d788cd32$var$numberFormat.format(value)}%`
                    },
                    beginAtZero: true,
                    max: 100,
                    title: {
                        display: true,
                        text: "Percentuale"
                    }
                }
            }
        }
    });
    else if (isReady("ambito-benessere-chart") && hasAmbitoBenessere && $b711c676d788cd32$var$state.charts.ambitoBenessere) {
        $b711c676d788cd32$var$state.charts.ambitoBenessere.data.labels = ambitoBenessereLabels;
        $b711c676d788cd32$var$state.charts.ambitoBenessere.data.datasets[0].data = soddisfazioneAmbito;
        $b711c676d788cd32$var$state.charts.ambitoBenessere.data.datasets[1].data = stressAmbito;
        $b711c676d788cd32$var$state.charts.ambitoBenessere.data.datasets[2].data = crescitaAmbito;
        $b711c676d788cd32$var$state.charts.ambitoBenessere.update();
    }
    if ($b711c676d788cd32$var$state.geo) {
        const regionBuckets = {};
        filtered.forEach((row)=>{
            const value = $b711c676d788cd32$var$normalizeValue(row.regione);
            if (!value) return;
            const ralValue = $b711c676d788cd32$var$parseRal(row.ral);
            if (!regionBuckets[value]) regionBuckets[value] = [];
            if (ralValue !== null) regionBuckets[value].push(ralValue);
        });
        const regionDataAvg = $b711c676d788cd32$var$state.geo.features.map((feature)=>{
            const name = feature.properties.reg_name;
            const values = regionBuckets[name] || [];
            const trimmed = $b711c676d788cd32$var$trimRal(values);
            if (trimmed.length < $b711c676d788cd32$var$MIN_SAMPLE) return {
                feature: feature,
                value: null,
                count: values.length,
                name: name
            };
            const stats = $b711c676d788cd32$var$computeStats(trimmed, false);
            return {
                feature: feature,
                value: stats.avg,
                count: trimmed.length,
                name: name
            };
        });
        const regionDataMedian = $b711c676d788cd32$var$state.geo.features.map((feature)=>{
            const name = feature.properties.reg_name;
            const values = regionBuckets[name] || [];
            const trimmed = $b711c676d788cd32$var$trimRal(values);
            if (trimmed.length < $b711c676d788cd32$var$MIN_SAMPLE) return {
                feature: feature,
                value: null,
                count: values.length,
                name: name
            };
            const stats = $b711c676d788cd32$var$computeStats(trimmed, false);
            return {
                feature: feature,
                value: stats.median,
                count: trimmed.length,
                name: name
            };
        });
        const baseMapOptions = {
            responsive: true,
            layout: {
                padding: 0
            },
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    callbacks: {
                        label: (context)=>{
                            const raw = context.raw || {};
                            if (!raw.value) return `${raw.name}: campione insufficiente`;
                            return `${raw.name}: ${$b711c676d788cd32$var$currency.format(raw.value)} (n=${$b711c676d788cd32$var$countFormat.format(raw.count)})`;
                        }
                    }
                }
            },
            scales: {
                projection: {
                    axis: "x",
                    projection: "mercator"
                },
                color: {
                    axis: "x",
                    quantize: 5
                }
            }
        };
        const hasRegionAvg = regionDataAvg.some((item)=>item.value !== null);
        const hasRegionMedian = regionDataMedian.some((item)=>item.value !== null);
        if (isReady("regione-media-chart")) {
            $b711c676d788cd32$var$setChartEmpty("regione-media-chart", !hasRegionAvg);
            if (!hasRegionAvg) {
                if ($b711c676d788cd32$var$state.charts.regioneAvg) {
                    $b711c676d788cd32$var$state.charts.regioneAvg.destroy();
                    $b711c676d788cd32$var$state.charts.regioneAvg = null;
                }
            }
        }
        if (isReady("regione-mediana-chart")) {
            $b711c676d788cd32$var$setChartEmpty("regione-mediana-chart", !hasRegionMedian);
            if (!hasRegionMedian) {
                if ($b711c676d788cd32$var$state.charts.regioneMedian) {
                    $b711c676d788cd32$var$state.charts.regioneMedian.destroy();
                    $b711c676d788cd32$var$state.charts.regioneMedian = null;
                }
            }
        }
        if (isReady("regione-media-chart") && hasRegionAvg && !$b711c676d788cd32$var$state.charts.regioneAvg) $b711c676d788cd32$var$state.charts.regioneAvg = new Chart(document.getElementById("regione-media-chart"), {
            type: "choropleth",
            data: {
                labels: $b711c676d788cd32$var$state.geo.features.map((f)=>f.properties.reg_name),
                datasets: [
                    {
                        label: "RAL media",
                        data: regionDataAvg,
                        outline: $b711c676d788cd32$var$state.geo.features
                    }
                ]
            },
            options: baseMapOptions
        });
        else if (isReady("regione-media-chart") && hasRegionAvg && $b711c676d788cd32$var$state.charts.regioneAvg) {
            $b711c676d788cd32$var$state.charts.regioneAvg.data.datasets[0].data = regionDataAvg;
            $b711c676d788cd32$var$state.charts.regioneAvg.update();
        }
        if (isReady("regione-mediana-chart") && hasRegionMedian && !$b711c676d788cd32$var$state.charts.regioneMedian) $b711c676d788cd32$var$state.charts.regioneMedian = new Chart(document.getElementById("regione-mediana-chart"), {
            type: "choropleth",
            data: {
                labels: $b711c676d788cd32$var$state.geo.features.map((f)=>f.properties.reg_name),
                datasets: [
                    {
                        label: "RAL mediana",
                        data: regionDataMedian,
                        outline: $b711c676d788cd32$var$state.geo.features
                    }
                ]
            },
            options: baseMapOptions
        });
        else if (isReady("regione-mediana-chart") && hasRegionMedian && $b711c676d788cd32$var$state.charts.regioneMedian) {
            $b711c676d788cd32$var$state.charts.regioneMedian.data.datasets[0].data = regionDataMedian;
            $b711c676d788cd32$var$state.charts.regioneMedian.update();
        }
    }
}
function $b711c676d788cd32$var$applyFilters() {
    const filters = {
        genere: document.getElementById("filter-genere").value,
        regione: document.getElementById("filter-regione").value,
        settore: document.getElementById("filter-settore").value,
        seniority: document.getElementById("filter-seniority").value,
        rapporto: document.getElementById("filter-rapporto").value,
        modalita: document.getElementById("filter-modalita").value,
        eta: document.getElementById("filter-eta").value,
        esperienza: document.getElementById("filter-esperienza").value,
        ralMin: Number(document.getElementById("filter-ral-min").value || 0),
        ralMax: Number(document.getElementById("filter-ral-max").value || Infinity)
    };
    $b711c676d788cd32$var$state.filtered = $b711c676d788cd32$var$state.raw.filter((row)=>{
        if (filters.genere && $b711c676d788cd32$var$normalizeValue(row.genere) !== filters.genere) return false;
        if (filters.regione && $b711c676d788cd32$var$normalizeValue(row.regione) !== filters.regione) return false;
        if (filters.settore && $b711c676d788cd32$var$normalizeValue(row.settore) !== filters.settore) return false;
        if (filters.seniority && $b711c676d788cd32$var$normalizeValue(row.seniority) !== filters.seniority) return false;
        if (filters.rapporto && $b711c676d788cd32$var$normalizeValue(row.rapporto) !== filters.rapporto) return false;
        if (filters.modalita && $b711c676d788cd32$var$normalizeValue(row["modalita-lavoro"]) !== filters.modalita) return false;
        if (filters.eta && $b711c676d788cd32$var$normalizeValue(row.eta) !== filters.eta) return false;
        if (filters.esperienza && $b711c676d788cd32$var$normalizeValue(row.esperienza) !== filters.esperienza) return false;
        const ralValue = $b711c676d788cd32$var$parseRal(row.ral);
        if (ralValue === null) return false;
        if (ralValue < filters.ralMin || ralValue > filters.ralMax) return false;
        return true;
    });
    const ralValues = $b711c676d788cd32$var$state.filtered.map((row)=>$b711c676d788cd32$var$parseRal(row.ral)).filter((value)=>value !== null);
    const ralTrimmed = $b711c676d788cd32$var$trimRal(ralValues);
    const stats = $b711c676d788cd32$var$computeStats(ralTrimmed, false);
    document.getElementById("filtered-count").textContent = ralTrimmed.length.toLocaleString("it-IT");
    document.getElementById("filtered-avg").textContent = stats.avg ? $b711c676d788cd32$var$currency.format(stats.avg) : "--";
    document.getElementById("filtered-median").textContent = stats.median ? $b711c676d788cd32$var$currency.format(stats.median) : "--";
    document.getElementById("filtered-range").textContent = stats.min !== null ? `${$b711c676d788cd32$var$currency.format(stats.min)} - ${$b711c676d788cd32$var$currency.format(stats.max)}` : "--";
    $b711c676d788cd32$var$updateCharts($b711c676d788cd32$var$state.filtered);
}
function $b711c676d788cd32$var$attachFilterListeners() {
    document.querySelectorAll(".filters select, .filters input").forEach((input)=>{
        input.addEventListener("change", $b711c676d788cd32$var$applyFilters);
    });
    document.getElementById("reset-filters").addEventListener("click", ()=>{
        document.querySelectorAll(".filters select").forEach((select)=>{
            select.value = "";
        });
        document.getElementById("filter-ral-min").value = "";
        document.getElementById("filter-ral-max").value = "";
        $b711c676d788cd32$var$applyFilters();
    });
}
function $b711c676d788cd32$var$initOverviewToggle() {
    const toggle = document.getElementById("overview-toggle");
    const details = document.getElementById("overview-details");
    if (!toggle || !details) return;
    const mobileQuery = window.matchMedia("(max-width: 640px)");
    const setExpanded = (expanded)=>{
        details.hidden = !expanded;
        toggle.setAttribute("aria-expanded", String(expanded));
        toggle.setAttribute("aria-label", expanded ? "Nascondi dettagli" : "Mostra dettagli");
    };
    const syncLayout = ()=>{
        if (mobileQuery.matches) {
            setExpanded(false);
            return;
        }
        details.hidden = false;
        toggle.setAttribute("aria-expanded", "true");
        toggle.setAttribute("aria-label", "Nascondi dettagli");
    };
    toggle.addEventListener("click", ()=>{
        setExpanded(toggle.getAttribute("aria-expanded") !== "true");
    });
    syncLayout();
    mobileQuery.addEventListener("change", syncLayout);
}
function $b711c676d788cd32$var$initFiltersToggle() {
    const toggle = document.getElementById("filters-toggle");
    const details = document.getElementById("filters-details");
    if (!toggle || !details) return;
    const mobileQuery = window.matchMedia("(max-width: 768px)");
    const setExpanded = (expanded)=>{
        details.hidden = !expanded;
        toggle.setAttribute("aria-expanded", String(expanded));
        toggle.setAttribute("aria-label", expanded ? "Nascondi filtri" : "Mostra filtri");
    };
    const syncLayout = ()=>{
        if (mobileQuery.matches) {
            setExpanded(false);
            return;
        }
        details.hidden = false;
        toggle.setAttribute("aria-expanded", "true");
        toggle.setAttribute("aria-label", "Nascondi filtri");
    };
    toggle.addEventListener("click", ()=>{
        setExpanded(toggle.getAttribute("aria-expanded") !== "true");
    });
    syncLayout();
    mobileQuery.addEventListener("change", syncLayout);
}
function $b711c676d788cd32$var$hydrateOverview(data) {
    const timestamps = data.map((row)=>row.timestamp).filter((value)=>value);
    const lastUpdated = timestamps.length ? timestamps.sort().slice(-1)[0] : null;
    const ralValues = data.map((row)=>$b711c676d788cd32$var$parseRal(row.ral)).filter((value)=>value !== null);
    const ralTrimmed = $b711c676d788cd32$var$trimRal(ralValues);
    const stats = $b711c676d788cd32$var$computeStats(ralTrimmed, false);
    const soddisfazioneValues = data.map((row)=>$b711c676d788cd32$var$parseScale(row.soddisfazione)).filter((value)=>value !== null);
    const stressValues = data.map((row)=>$b711c676d788cd32$var$parseScale(row.stress)).filter((value)=>value !== null);
    const crescitaValues = data.map((row)=>$b711c676d788cd32$var$parseScale(row.crescita)).filter((value)=>value !== null);
    const soddisfazioneTrimmed = $b711c676d788cd32$var$trimOutliers(soddisfazioneValues);
    const stressTrimmed = $b711c676d788cd32$var$trimOutliers(stressValues);
    const soddisfazioneStats = $b711c676d788cd32$var$computeStats(soddisfazioneTrimmed, false);
    const stressStats = $b711c676d788cd32$var$computeStats(stressTrimmed, false);
    const crescitaTrimmed = $b711c676d788cd32$var$trimOutliers(crescitaValues);
    const crescitaStats = $b711c676d788cd32$var$computeStats(crescitaTrimmed, false);
    document.getElementById("last-updated").textContent = $b711c676d788cd32$var$formatDate(lastUpdated);
    document.getElementById("total-count").textContent = ralTrimmed.length.toLocaleString("it-IT");
    const rawCountEl = document.getElementById("raw-count");
    if (rawCountEl) rawCountEl.textContent = ralValues.length.toLocaleString("it-IT");
    const trimmedCountEl = document.getElementById("trimmed-count");
    if (trimmedCountEl) trimmedCountEl.textContent = ralTrimmed.length.toLocaleString("it-IT");
    document.getElementById("avg-ral").textContent = stats.avg ? $b711c676d788cd32$var$currency.format(stats.avg) : "--";
    document.getElementById("median-ral").textContent = stats.median ? $b711c676d788cd32$var$currency.format(stats.median) : "--";
    document.getElementById("avg-soddisfazione").textContent = soddisfazioneStats.avg ? `${$b711c676d788cd32$var$numberFormat.format($b711c676d788cd32$var$scaleToPercent(soddisfazioneStats.avg))}%` : "--";
    document.getElementById("avg-stress").textContent = stressStats.avg ? `${$b711c676d788cd32$var$numberFormat.format($b711c676d788cd32$var$scaleToPercent(stressStats.avg))}%` : "--";
    document.getElementById("avg-crescita").textContent = crescitaStats.avg ? `${$b711c676d788cd32$var$numberFormat.format($b711c676d788cd32$var$scaleToPercent(crescitaStats.avg))}%` : "--";
}
function $b711c676d788cd32$var$populateFilters(data) {
    $b711c676d788cd32$var$setOptions(document.getElementById("filter-genere"), $b711c676d788cd32$var$uniqueValues(data, "genere"));
    $b711c676d788cd32$var$setOptions(document.getElementById("filter-regione"), $b711c676d788cd32$var$uniqueValues(data, "regione"));
    $b711c676d788cd32$var$setOptions(document.getElementById("filter-settore"), $b711c676d788cd32$var$uniqueValues(data, "settore"));
    $b711c676d788cd32$var$setOptions(document.getElementById("filter-seniority"), $b711c676d788cd32$var$uniqueValues(data, "seniority"));
    $b711c676d788cd32$var$setOptions(document.getElementById("filter-rapporto"), $b711c676d788cd32$var$uniqueValues(data, "rapporto"));
    $b711c676d788cd32$var$setOptions(document.getElementById("filter-modalita"), $b711c676d788cd32$var$uniqueValues(data, "modalita-lavoro"));
    $b711c676d788cd32$var$setOptions(document.getElementById("filter-eta"), $b711c676d788cd32$var$uniqueValues(data, "eta"));
    $b711c676d788cd32$var$setOptionsOrdered(document.getElementById("filter-esperienza"), $b711c676d788cd32$var$ESPERIENZA_ORDER, $b711c676d788cd32$var$uniqueValues(data, "esperienza"));
}
function $b711c676d788cd32$var$loadCsv() {
    return fetch($b711c676d788cd32$var$CSV_URL).then((response)=>{
        if (!response.ok) throw new Error("Impossibile caricare il dataset");
        return response.text();
    }).then((csvText)=>new Promise((resolve, reject)=>{
            Papa.parse(csvText, {
                header: true,
                skipEmptyLines: true,
                complete: (result)=>resolve(result.data),
                error: reject
            });
        }));
}
function $b711c676d788cd32$var$loadGeoJson() {
    return fetch($b711c676d788cd32$var$GEOJSON_URL).then((response)=>{
        if (!response.ok) throw new Error("Impossibile caricare la mappa regioni");
        return response.json();
    });
}
function $b711c676d788cd32$var$ensureGeoChartRegistered() {
    const chartGeo = window.ChartGeo;
    if (!chartGeo || $b711c676d788cd32$var$ensureGeoChartRegistered.done) return;
    Chart.register(chartGeo.ChoroplethController, chartGeo.ColorScale, chartGeo.GeoFeature, chartGeo.ProjectionScale);
    $b711c676d788cd32$var$ensureGeoChartRegistered.done = true;
}
document.addEventListener("DOMContentLoaded", async ()=>{
    const spinner = document.getElementById("loading-spinner");
    const dashboardRoot = document.getElementById("dashboard-root");
    $b711c676d788cd32$var$initOverviewToggle();
    $b711c676d788cd32$var$initFiltersToggle();
    try {
        const [data, geo] = await Promise.all([
            $b711c676d788cd32$var$loadCsv(),
            $b711c676d788cd32$var$loadGeoJson()
        ]);
        $b711c676d788cd32$var$state.raw = data;
        $b711c676d788cd32$var$state.geo = geo;
        $b711c676d788cd32$var$ensureGeoChartRegistered();
        $b711c676d788cd32$var$hydrateOverview(data);
        $b711c676d788cd32$var$populateFilters(data);
        $b711c676d788cd32$var$attachFilterListeners();
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (!entry.isIntersecting) return;
                if (entry.target?.id) {
                    $b711c676d788cd32$var$state.chartReady.add(entry.target.id);
                    observer.unobserve(entry.target);
                }
            });
            if ($b711c676d788cd32$var$state.filtered.length) $b711c676d788cd32$var$updateCharts($b711c676d788cd32$var$state.filtered);
        }, {
            rootMargin: "200px 0px"
        });
        document.querySelectorAll("[data-lazy-chart]").forEach((el)=>observer.observe(el));
        $b711c676d788cd32$var$applyFilters();
    } catch (error) {
        console.error(error);
        const lastUpdated = document.getElementById("last-updated");
        if (lastUpdated) lastUpdated.textContent = "Errore";
    } finally{
        if (spinner) spinner.classList.add("hidden");
        if (dashboardRoot) dashboardRoot.style.display = "block";
    }
});


//# sourceMappingURL=osservatorio.a1e0a610.js.map
